import { call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { setFeedbackData } from '../../../state/feedback/feedbackSlice';

export function* fetchFeedbackSaga() {
    try {
        const response = yield call(axios.get,
            'https://raw.githubusercontent.com/BlinkVoice/publicFiles/refs/heads/main/features/updates',
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }
        );

        const jsonData = typeof response.data === 'string' ?
            JSON.parse(response.data) : response.data;

        yield put(setFeedbackData(jsonData));

    } catch (error) {
        console.error('Error fetching feedback:', error);
    }
}
